import React from 'react';
import {Form} from 'antd';
import NHUpload from '../NHUpload';
import {createUuid} from  '../../../utils/NHCore';
const FormItem=Form.Item;

class ExcelForm extends React.Component{

    render(){
        const formItemLayout = {
            labelCol: {
              xs: { span: 24 },
              sm: { span: 5 },
            },
            wrapperCol: {
              xs: { span: 24 },
              sm: { span: 19 },
            },
          };
        let {form,formItemList} = this.props;
        const {getFieldDecorator } = form;
        formItemList =formItemList?formItemList:[];
        let list=[];
        formItemList.map((item,index) => {
            list.push(<FormItem
                {...formItemLayout}
                label={item.label}
                key={createUuid()}
            >
                {getFieldDecorator(item.key, {
                    rules: [
                        {
                            required: item.required===true?true:false,
                            message:item.message?item.message:item.label+'不能为空'
                        }
                    ],
                    initialValue:item.initialValue
                })(
                    item.render()
                )}
            </FormItem>);
        })


        return (
            <Form>
                <FormItem
                    {...formItemLayout}
                    label="上传文件"
                >
                    {getFieldDecorator('uuid', { rules: [{required: true,message: '请上传需要导入的文件！'}]})(
                        <NHUpload
                            uploadType={'redis'}
                            fileTypeLimit={['exce']}
                        ></NHUpload>
                    )}
                </FormItem>
                {
                    list
                }
             </Form>
        )

    }
}
export default Form.create()(ExcelForm);



// WEBPACK FOOTER //
// ./components/common/NHNewExcel/ExcelForm.js